// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","item":"QCcaQt8vgsrNWKDqeHyow","itemVisible":"_1kPruW8_Fe7xln21IUR93v"};